var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTtfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16526 17.7931V6.2069C7.16526 5.90219 6.9229 5.65517 6.62394 5.65517H5V4H18.5328L19 7.31034H17.4502L16.5284 5.90069C16.4279 5.74727 16.2589 5.65514 16.078 5.65517H11.4958C11.1968 5.65517 10.9545 5.90219 10.9545 6.2069V11.1724H16.3676V12.8276H10.9545V17.7931C10.9545 18.0978 11.1968 18.3448 11.4958 18.3448H13.1197V20H5V18.3448H6.62394C6.9229 18.3448 7.16526 18.0978 7.16526 17.7931Z",
    fill: "#637282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTtfIcon);
export default __webpack_public_path__ + "static/media/ttf-icon.9b60e1e9.svg";
export { ForwardRef as ReactComponent };